<div class="content">
  @if (errorMessage) {
    <div class="errorMessage">
      {{ errorMessage }}
    </div>
  }
  <div class="inputRow">
    <mat-form-field class="inputField">
      <mat-label>Quantity</mat-label>
      <input [disabled]="isBusy" type="number" matInput [(ngModel)]="quantity"/>
    </mat-form-field>
    <button [disabled]="isBusy || quantity === 0" class="tagsButton" matButton="elevated" (click)="showTagsDialog()">Set Tag Information</button>
  </div>
  <div class="buttonRow">
    <span class="spacer"></span>
    <button class="dialogButton warn-button" [disabled]="isBusy" matButton="elevated" (click)="cancel()">
      <span>
        <mat-icon class="size-16">cancel</mat-icon>
        <label class="buttonLabel">Cancel</label>
      </span>
    </button>
    <button class="dialogButton primary-button" [disabled]="isBusy" matButton="elevated" (click)="save()">
      <span>
        <mat-icon class="size-16">save</mat-icon>
        <label class="buttonLabel">Save</label>
      </span>
    </button>
  </div>
</div>
